import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import axios from "axios";
import { useUserChildsUIContext } from "../UserChildsUIContext";

const selectedAccounts = (entities, ids) => {
  const _customers = [];
  ids.forEach((id) => {
    const customer = entities.find((el) => el.id === id);
    if (customer) {
      _customers.push(customer);
    }
  });
  return _customers;
};

export function UnassignedCustomersFetchDialog({ show, onHide }) {
  // Customers UI Context
  const customersUIContext = useUserChildsUIContext();

  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState(null);

  const handleOk = () => {
    let data = {
      accountIds: customersUIContext.ids,
      managerId: selectedManager,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}system-user-assign-customer`,
        data
      )
      //.then((response) => response.data)
      .then((response) => {
        onHide();
      })
      .then(() => {});
  };
  const customersUIProps = useMemo(() => {
    return {
      ids: customersUIContext.ids,
    };
  }, [customersUIContext]);

  // Customers Redux state
  const { customers } = useSelector(
    (state) => ({
      customers: selectedAccounts(
        state.userChilds.entities,
        customersUIProps.ids
      ),
    }),
    shallowEqual
  );

  // if customers weren't selected we should close modal
  useEffect(() => {
    if (!customersUIProps.ids || customersUIProps.ids.length === 0) {
      onHide();
    }

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}system-user`)
      //.then((response) => response.data)
      // .then((response) => [
      //   { id: "23434234", name: "zion" },
      //   { id: "234234324", name: "alon" },
      // ])
      .then((response) => response.data)
      .then(setManagers)
      .then(() => {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table table-head-custom table-vertical-center overflow-hidden">
          <thead>
            <tr>
              <th>ACCOUNT</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr key={`id${customer.id}`}>
                {/* <td>{customer.id}</td> */}
                <td>
                  <span className="ml-3">{customer.name}</span>
                </td>
                {/* <td>
                  <span className="ml-3">{customer.customerCode}</span>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
        <select
          className="custom-select"
          onChange={(val) => setSelectedManager(val.target.value)}
        >
          {managers.map((manager) => (
            <option key={manager._id} value={manager._id}>
              {manager.firstName} {manager.lastName}
            </option>
          ))}
        </select>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={handleOk}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
